import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PaginationModule } from "ngx-bootstrap/pagination";
import { TabsModule } from "ngx-bootstrap/tabs";

import { IframeContainerComponent } from "./components/iframe-container/iframe-container.component";
import { DatatableComponent } from "./components/datatable/datatable.component";
import { TableCheckboxComponent } from "./components/table-checkbox/table-checkbox.component";
import { TableHeaderCheckboxComponent } from "./components/table-header-checkbox/table-header-checkbox.component";
import { TranslateModule } from "@ngx-translate/core";
import { ReactiveFormsModule } from "@angular/forms";
import { PickListComponent } from "./components/pick-list/pick-list.component";
import { OrderColumnIconComponent } from "./components/order-column-icon/order-column-icon.component";
import { SearchDatatableModalComponent } from "./components/search-datatable-modal/search-datatable-modal.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { AtlasFormElementValidatorDirective } from "./directives/atlas-form-element-validator.directive";
import { AtlasFormElementDirective } from "./directives/atlas-form-element.directive";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { defineLocale, ptBrLocale } from "ngx-bootstrap/chronos";

import { CheckboxComponent } from "./components/atlas/checkbox/checkbox.component";
import { ValidateSignatureErrorModalComponent } from "./components/validate-signature-error-modal/validate-signature-error-modal.component";
import { CropImageModalComponent } from "./components/crop-image-modal/crop-image-modal.component";
import { ImageCropperComponent } from "ngx-image-cropper";
import { ModalComponent } from "./components/atlas/modal/modal.component";
import { InputComponent } from "./components/atlas/input/input.component";

import { CdkStepperModule } from "@angular/cdk/stepper";
import { FileDragAndDropHoverDirective } from "./components/atlas/file-drag-and-drop/directives/file-drag-and-drop-hover.directive";
import { CheckboxDetailsComponent } from "./components/atlas/checkbox-details/checkbox-details.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { ButtonComponent } from "./components/atlas/button/button.component";
import { LoadingOverlayComponent } from "./components/atlas/loading-overlay/loading-overlay.component";
import { StepLazyRenderingDirective } from "./components/atlas/stepper/directives/step-lazy-rendering.directive";
import { SkeletonComponent } from "./components/atlas/skeleton/skeleton.component";
import { WizardComponent } from "./components/wizard/wizard.component";

import { A11yModule } from "@angular/cdk/a11y";
import { CurrencyDirective } from "./directives/currency.directive";

import { CdkTree, CdkTreeModule, CdkTreeNode } from "@angular/cdk/tree";
import { TreeComponent } from "./components/atlas/tree/tree.component";
import { ModalUnsavedChangesComponent } from "./components/atlas/modals/modal-unsaved-changes/modal-unsaved-changes.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { ModalDangerComponent } from "./components/atlas/modals/modal-danger/modal-danger.component";
import { ModalConfirmChangeComponent } from "./components/atlas/modals/modal-confirm-change/modal-confirm-change.component";
import { PopoverModule } from "ngx-bootstrap/popover";
import { AtlasModalComponent } from "@shared/components/atlas/atlas-modal/atlas-modal.component";
import { ModalUserSurveyComponent } from "@shared/components/atlas/modals/modal-user-survey/modal-user-survey.component";
import { YouTubePlayer } from "@angular/youtube-player";
import { MatTreeModule } from "@angular/material/tree";
import { IframeSanitizerPipe } from "./pipes";
import { NumberDirective } from "./directives/number.directive";
import { SkeletonDirective } from "./directives/skeleton.directive";
import { AutomataTemplateDirective } from "./directives/automata-template.directive";

defineLocale("pt-br", ptBrLocale);

@NgModule({
	declarations: [
		IframeContainerComponent,
		DatatableComponent,
		TableCheckboxComponent,
		TableHeaderCheckboxComponent,
		ModalComponent,
		PickListComponent,
		OrderColumnIconComponent,
		SearchDatatableModalComponent,
		InputComponent,
		CheckboxComponent,
		ValidateSignatureErrorModalComponent,
		CropImageModalComponent,
		FileDragAndDropHoverDirective,
		CheckboxDetailsComponent,
		ButtonComponent,
		LoadingOverlayComponent,
		StepLazyRenderingDirective,
		SkeletonComponent,
		WizardComponent,
		TreeComponent,
		ModalUnsavedChangesComponent,
		ModalDangerComponent,
		ModalConfirmChangeComponent,
		AtlasModalComponent,
		ModalUserSurveyComponent
	],
	providers: [provideNgxMask(), CdkTree, CdkTreeNode],
	imports: [
		CommonModule,
		PaginationModule,
		TabsModule,
		TranslateModule,
		ModalModule,
		CdkStepperModule,
		BsDatepickerModule,
		ReactiveFormsModule,
		ImageCropperComponent,
		NgSelectModule,
		CdkTreeModule,
		A11yModule,
		TooltipModule,
		NgxMaskDirective,
		NgxMaskPipe,
		PopoverModule,
		YouTubePlayer,
		CdkTreeModule,
		MatTreeModule,
		IframeSanitizerPipe,
		CurrencyDirective,
		NumberDirective,
		SkeletonDirective,
		AutomataTemplateDirective,
		AtlasFormElementValidatorDirective,
		AtlasFormElementDirective
	],
	exports: [
		IframeContainerComponent,
		DatatableComponent,
		TableCheckboxComponent,
		TableHeaderCheckboxComponent,
		TranslateModule,
		ReactiveFormsModule,
		TabsModule,
		ModalModule,
		PaginationModule,
		PickListComponent,
		OrderColumnIconComponent,
		BsDatepickerModule,
		InputComponent,
		CheckboxComponent,
		CropImageModalComponent,
		CdkStepperModule,
		FileDragAndDropHoverDirective,
		CheckboxDetailsComponent,
		ButtonComponent,
		LoadingOverlayComponent,
		StepLazyRenderingDirective,
		WizardComponent,
		TreeComponent,
		ModalUserSurveyComponent,
		CdkTreeModule,
		MatTreeModule
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
